import { render, staticRenderFns } from "./PakamInfoStep.vue?vue&type=template&id=49a54543&scoped=true"
import script from "./PakamInfoStep.vue?vue&type=script&lang=js"
export * from "./PakamInfoStep.vue?vue&type=script&lang=js"
import style0 from "./PakamInfoStep.vue?vue&type=style&index=0&id=49a54543&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a54543",
  null
  
)

export default component.exports